export const ENVIRONMENTS = {
  family: { label: "Familia", emoji: "🏡", color: "#FFA689", text: "#C25E3F", desc: "Tu hogar y los tuyos" },
  work: { label: "Trabajo", emoji: "💼", color: "#5C8EAD", text: "#3E6B87", desc: "Equipos y proyectos profesionales" },
  club: { label: "Club", emoji: "⚽", color: "#81C784", text: "#3E7D4C", desc: "Clubes, asociaciones y comunidades" },
  travel: { label: "Viajes", emoji: "✈️", color: "#FFB74D", text: "#A8690F", desc: "Escapadas y aventuras en grupo" },
  other: { label: "Otro", emoji: "✨", color: "#D0ACF9", text: "#7E57C2", desc: "Todo lo demás, a tu manera" },
};

export const ENV_ORDER = ["family", "work", "club", "travel", "other"];

export const TYPE_TO_ENV = { familiar: "family", empresa: "work", club: "club", personalizado: "other" };

export const envKeyOf = (ws) => ws?.environment || TYPE_TO_ENV[ws?.type] || "other";
export const envOf = (ws) => ENVIRONMENTS[envKeyOf(ws)];

// 8-digit hex alpha tint, e.g. tint("#FFA689", 0.15)
export const tint = (hex, alpha) => hex + Math.round(alpha * 255).toString(16).padStart(2, "0");
